import styled from "styled-components";
import { ReactNode } from "react";

interface LinkContentProps {
  linkContent: string;
  url: string;
  linkBtn?: string;
  target?: string;
  linkStyle?: string;
  icon?: ReactNode;
}

const LinkBtn = ({
  linkContent,
  url,
  linkBtn,
  target,
  linkStyle,
  icon,
}: LinkContentProps) => {
  return (
    <LinkBtnWrapper className={linkBtn}>
      <a
        href={url}
        target={target}
        rel="noopener noreferrer"
        className={linkStyle}
      >
        {linkContent}
      </a>
      {icon}
    </LinkBtnWrapper>
  );
};

export default LinkBtn;

const LinkBtnWrapper = styled.button`
  border: none;
  background: none;
  display: flex;
  align-items: center;
  gap: 4px;

  > a {
    color: #000;
    text-decoration: none;
    font-size: 24px;
  }

  @media screen and (max-width: 640px) {
    > a {
      font-size: 18px;
    }
  }
`;
